$(document).ready(function() {
	if(!document.querySelector('.GPC0062')) return false;

	var $obj = $('.GPC0062');
	var waNumber = 0;
	$obj.find('.unit-list .unit-box').each(function() {
		var $target;
		if($(this).find('.title') && !$(this).find('.title').is(':empty')) {
			$target = $(this).find('.title');
		}
		if($target) {
			$target.attr('id', 'waGPC0062_'+waNumber);
			$(this).find('a.btn').attr('aria-describedby', 'waGPC0062_'+waNumber);
			$(this).find('a.link-text').attr('aria-describedby', 'waGPC0062_'+waNumber);
			waNumber++;
		}
	});
});